import React, { useRef } from "react";
import { ambiente_produccion } from "../../utils/Datos";
import logoCu from "../../assets/logos/logo-claveunica.svg";

export const ClaveUnicaLogin = () => {
  const form = useRef(null);

  const control = ambiente_produccion
    ? "https://calificaciones.penalolen.cl/successCuLogin"
    : "https://calificacionesdev.penalolen.cl/successCuLogin";

  // Para pruebas locales:
   //const control = "http://localhost:3000/successCuLogin";

  const handleCu = () => {
    form.current.submit();
  };

  return (
    <div className="text-center">
      <a
        type="button"
        className=" w-100 mt-3"
        onClick={handleCu}
      >
        <img src={logoCu} width="140" alt="ClaveÚnica" />
      </a>

      <form
        ref={form}
        action="https://claveunica.penalolen.cl/LoginCU/SolicitudCU"
        method="post"
      >
        <input name="app" value="Calificaciones" type="hidden" readOnly />
        <input name="param" value="login" type="hidden" readOnly />
        <input name="control" value={control} type="hidden" readOnly />
        <input name="metodo" value="get" type="hidden" readOnly />
      </form>
    </div>
  );
};